import React, { useState, useRef, useEffect } from "react";
import "./SchedulePanel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import EventModal from "../modals/EventModal";
import HTMLReader from "../modals/HTMLReader";
import MenuModal from "../modals/MenuModal";
import MoveEvents from "../modals/MoveEvents";
import EventEdit from "../modals/EventEdit";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import Common from "../../Common/Common";
import { urlSchemeToFunctions } from "../../CommonWeb/Common";
import RecalculateDialog from "../modals/RecalculateDialog";
import AlertModal from "../modals/AlertModal";
import { DateTime } from "luxon";
import Place from "../../Models/Place";
import Schedule from "../../Models/Schedule";
import GooglePlaces from "../../Models/GooglePlaces";
import { takeDailyLimitNotice, clearDailyLimitNotice } from "../../Common/GateLimit";
import PlaceEditModal from "../modals/PlaceEditModal";
import OpeningHoursFixModal from "../modals/OpeningHoursFixModal";
import FillIdleTimeModal from "../modals/FillIdleTimeModal";
import MultiSelectModal from "../modals/MultiSelectModal";
import PromptModal from "../modals/PromptModal";
import { dayStartLeg, dayEndLeg, hotelCategoryIds } from "../../Common/dayStartTravel";
import { pushStartTimes } from "../../Common/pushStart";
import { movedToNextDayMessage } from "../../Common/dayOverflow";

// The solid() macro resolves icons at compile time, so it can't take a
// runtime variable (Common.estimateTravel's mode) — a lookup table instead.
const TRAVEL_MODE_ICONS = {
  walk: solid("person-walking"),
  car: solid("car"),
  train: solid("train"),
  plane: solid("plane"),
};

const SchedulePanel = (props) => {
  const [eventModal, setEventModal] = useState(false);
  // "From your hotel" (no hotel known for that city): picking or searching
  // for the hotel — see dayStartTravel.js. hotelPick = { city, country, near }.
  const [hotelPick, setHotelPick] = useState(null);
  const [hotelSearchFor, setHotelSearchFor] = useState(null);
  const [hotelMessage, setHotelMessage] = useState(null);
  // EXPERIMENT, 2026-10-05: local dialog for Event Details instead of
  // dispatching to the Home tab, for now — see handleEventClicked below.
  const [EventHTMLReaderShow, setEventHTMLReaderShow] = useState(false);
  const [EventHTMLContent, setEventHTMLContent] = useState("");
  const [conflictPlaceEditShow, setConflictPlaceEditShow] = useState(false);
  const [conflictPlace, setConflictPlace] = useState(null);
  const [openingHoursFixShow, setOpeningHoursFixShow] = useState(false);
  const [openingHoursFixEvent, setOpeningHoursFixEvent] = useState(null);
  const [openingHoursFixConflict, setOpeningHoursFixConflict] = useState(null);
  const [openingHoursFixCandidates, setOpeningHoursFixCandidates] = useState([]);
  const [openingHoursFixReplaceCandidates, setOpeningHoursFixReplaceCandidates] = useState([]);
  const [openingHoursFixMode, setOpeningHoursFixMode] = useState(null);
  const [MenuModalShow, setMenuModalShow] = useState(false);
  const [MenuModalImage, setMenuModalImage] = useState(null);
  const [MenuModalList, setMenuModalList] = useState([]);
  const [MenuModalHeading, setMenuModalHeading] = useState("");
  const [MenuModalPlace, setMenuModalPlace] = useState(null);

  const [Mode, setMode] = useState("move_day");
  const [ParamDate, setParamDate] = useState(null);
  const [MoveEventsShow, setMoveEventsShow] = useState(false);
  const [ShowEventEdit, setShowEventEdit] = useState(false);
  const [EventEditMode, setShowEventMode] = useState("MODIFY");
  const [EventEditWhere, setShowEventWhere] = useState("after");
  const [dragEvent, setdragEvent] = useState(null);
  const [dragDay, setdragDay] = useState(null);
  const [RecalcDialogShow, setRecalcDialogShow] = useState(false);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const recalcDayDateRef = React.useRef(null);

  // const [list, setList] = useState([
  //   "The Call Of Ktulu",
  //   "For Whom The Bell Tolls",
  //   "The Day That Never Comes",
  //   "The Memory Remains",
  //   "Confusion",
  //   "Moth Into Flame",
  //   "The Outlaw Torn",
  //   "No Leaf Clover",
  //   "Halo on Fire",
  // ]);
  const dispatch = useDispatch();

  let schedule = useSelector((state) => state.schedule);
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let ScheduleNames = useSelector((state) => state.ScheduleNames);
  let LoadingGuide = useSelector((state) => state.LoadingGuide);
  let EventSearchText = useSelector((state) => state.EventSearchText);
  let GuideEditMode = useSelector((state) => state.GuideEditMode);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let MobileMode = useSelector((state) => state.MobileMode);
  let event = useSelector((state) => state.SelectedEvent);
  let dndEnabled = useSelector((state) => state.ScheduleDndEnabled);
  let user_info = useSelector((state) => state.user_info);
  let DayConflictBanner = useSelector((state) => state.DayConflictBanner);
  const advancedMode = user_info?.advanced_mode === "On";

  const clearEventSearchText = () => {
    //e.stopPropagation();
    dispatch(slice1Actions.setEventSearchText({ value: "" }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const showEventMenu = (e, event) => {
    e.stopPropagation();
    dispatch(slice1Actions.setSelectedEvent({ value: event }));
    setEventModal(true);
  };

  const showDayMenu = (e, event) => {
    e.stopPropagation();
    sectionClickedMenu(event);
  };

  //let Selevent = null;

  // Finds the specific place whose hours conflict with this event — used
  // both by the fix dialog's "View opening hours" fallback and internally.
  const findConflictingPlace = (event) => {
    const startTime = DateTime.fromISO(event.Start, { zone: "utc" });
    const endTime = DateTime.fromISO(event.End, { zone: "utc" });
    const placeIds = (event.Places || "").split(",").map((id) => id.trim()).filter(Boolean);
    const places = placeIds.map((id) => window.guide_obj.places.getPlace(id)).filter(Boolean);
    let conflictingPlace = places.find((place) => Place.isOpenAt(place, startTime) === false);
    // Not-open-yet-at-start takes priority (matches getOpeningHoursConflict);
    // otherwise fall back to whichever place's current period closes before
    // the event ends — the "closes_during" case.
    if (!conflictingPlace && endTime.isValid) {
      conflictingPlace = places.find((place) => {
        const minutesUntilClose = Place.minutesUntilCloseAt(place, startTime);
        return minutesUntilClose != null && endTime.diff(startTime, "minutes").minutes > minutesUntilClose;
      });
    }
    return conflictingPlace;
  };

  const viewOpeningHoursForEvent = (event) => {
    const conflictingPlace = findConflictingPlace(event);
    if (!conflictingPlace) return;
    setConflictPlace(conflictingPlace);
    setConflictPlaceEditShow(true);
  };

  // Same-itinerary events (any day — a place closed all day has no
  // same-day fix, only a different day works) that this event could trade
  // times with instead of just staying broken. See
  // Schedule.findSwapCandidates for the two-way fit check.
  const getItineraryEventsFor = (event) => {
    const eventItinerary = typeof event.Itinerary === "undefined" ? "Main" : event.Itinerary.replace(/%20/g, " ");
    return window.guide_obj.schedule.events.filter((e) => {
      const it = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary.replace(/%20/g, " ");
      return it === eventItinerary;
    });
  };

  // Replace candidates with NO opening hours recorded are offered as
  // "unknown" (never treated as closed) — so the dialog could suggest a
  // place that is in fact shut at that time. Common for places that came
  // from a guide rather than a Google search, which is also why Build My
  // Trip no longer looks up hours for every unscheduled leftover at build
  // time: it's done here instead, when it matters, for the nearest few
  // candidates only, then the list is recomputed with what was learned.
  // One attempt per place per session (a place Google has no hours for comes
  // back empty every time). 2026-10-13.
  const MAX_ON_DEMAND_HOURS = 6;
  const hoursAskedRef = useRef(new WeakSet());
  const fixEventRef = useRef(null);
  const [replaceChecking, setReplaceChecking] = useState(false);
  const [replaceLimited, setReplaceLimited] = useState(false);
  const checkReplaceCandidateHours = (event, replaceCandidates) => {
    fixEventRef.current = event;
    const need = replaceCandidates
      .filter((p) => !GooglePlaces.hasOpeningHoursData(p.OpeningHours) && !hoursAskedRef.current.has(p))
      .slice(0, MAX_ON_DEMAND_HOURS);
    setReplaceLimited(false);
    if (need.length === 0) { setReplaceChecking(false); return; }
    setReplaceChecking(true);
    clearDailyLimitNotice();
    let found = 0;
    Promise.all(need.map((p) => new Promise((resolve) => {
      hoursAskedRef.current.add(p);
      try {
        GooglePlaces.fetchOpeningHours(p, (hours) => { if (hours) { p.OpeningHours = hours; found++; } resolve(); });
      } catch (err) { resolve(); }
    }))).then(() => {
      // Hours are worth keeping — flag the guide so they get saved with it.
      if (found > 0) dispatch(slice1Actions.setGuideHasUnsavedChanges({ value: true }));
      // The dialog may have been closed, or reopened for another event, meanwhile.
      const limited = takeDailyLimitNotice();
      if (fixEventRef.current !== event) return;
      setReplaceChecking(false);
      setReplaceLimited(limited);
      setOpeningHoursFixReplaceCandidates(Schedule.findReplaceCandidates(event, Schedule.eventsCountedAsUsed(event.Itinerary), window.guide_obj.places));
    });
  };

  // Opens the fix dialog for this event's opening-hours conflict, offering
  // concrete resolutions (push start later / pull end earlier / exchange
  // with a compatible event) instead of just pointing at the place's hours
  // and leaving the user to work out a new time by hand.
  const handleShowOpeningHoursConflict = (e, event) => {
    e.stopPropagation();
    const conflict = Place.getOpeningHoursConflict(event, window.guide_obj.places);
    if (conflict.status !== "closed" && conflict.status !== "closes_during") return;
    const itineraryEvents = getItineraryEventsFor(event);
    const candidates = Schedule.findSwapCandidates(event, itineraryEvents, window.guide_obj.places);
    const replaceCandidates = Schedule.findReplaceCandidates(event, Schedule.eventsCountedAsUsed(event.Itinerary), window.guide_obj.places);
    setOpeningHoursFixEvent(event);
    setOpeningHoursFixConflict(conflict);
    setOpeningHoursFixCandidates(candidates);
    setOpeningHoursFixReplaceCandidates(replaceCandidates);
    setOpeningHoursFixMode(null);
    setOpeningHoursFixShow(true);
    checkReplaceCandidateHours(event, replaceCandidates);
  };

  // General-purpose "Swap or Replace Event" — available from the event
  // menu any time, not just when this event has an opening-hours conflict.
  // Swap candidates are still limited to the same two-way opening-hours
  // fit check as the conflict-resolution flow (Schedule.findSwapCandidates):
  // freely rearranging times shouldn't be able to accidentally swap a
  // place into a slot where it'd then be closed. Replace candidates
  // (Schedule.findReplaceCandidates) are unused guide places whose hours
  // already fit this event's existing time, so substituting one in is
  // always safe regardless of conflict state.
  const openSwapForEvent = (event) => {
    const itineraryEvents = getItineraryEventsFor(event);
    const candidates = Schedule.findSwapCandidates(event, itineraryEvents, window.guide_obj.places);
    const replaceCandidates = Schedule.findReplaceCandidates(event, Schedule.eventsCountedAsUsed(event.Itinerary), window.guide_obj.places);
    setOpeningHoursFixEvent(event);
    setOpeningHoursFixConflict(null);
    setOpeningHoursFixCandidates(candidates);
    setOpeningHoursFixReplaceCandidates(replaceCandidates);
    setOpeningHoursFixMode("swap");
    setOpeningHoursFixShow(true);
    checkReplaceCandidateHours(event, replaceCandidates);
  };

  const closeOpeningHoursFix = () => { fixEventRef.current = null; setReplaceChecking(false); setOpeningHoursFixShow(false); };

  const applyPushStart = () => {
    const event = openingHoursFixEvent;
    const minutesUntilOpen = openingHoursFixConflict.minutesUntilOpen;
    const { Start, End } = pushStartTimes(event, minutesUntilOpen);
    event.Start = Start;
    event.End = End;
    closeOpeningHoursFix();
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const applyPullEnd = () => {
    const event = openingHoursFixEvent;
    const minutesUntilClose = openingHoursFixConflict.minutesUntilClose;
    event.End = DateTime.fromISO(event.Start, { zone: "utc" }).plus({ minutes: minutesUntilClose }).toISO();
    closeOpeningHoursFix();
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  // A new place in a day can need more travel time than the gap before the next
  // stop: push that day's later stops as needed (Schedule.makeRoomForTravel).
  const makeRoomForTravel = (event) =>
    Schedule.makeRoomForTravel(window.guide_obj.schedule.events, window.guide_obj.places, Schedule.isoOf(event.Start).slice(0, 10), event.Itinerary || "Main");

  const applySwap = (candidate) => {
    const event = openingHoursFixEvent;
    const tmpStart = event.Start;
    const tmpEnd = event.End;
    event.Start = candidate.Start;
    event.End = candidate.End;
    candidate.Start = tmpStart;
    candidate.End = tmpEnd;
    makeRoomForTravel(event);
    makeRoomForTravel(candidate);
    closeOpeningHoursFix();
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  // One-directional: substitutes the specific conflicting place (found the
  // same way the "View this place's opening hours" fallback does) within
  // the event's Places list for the chosen unused place, leaving every
  // other place already attached to this event untouched. The event's own
  // time never changes — findReplaceCandidates already only offers places
  // whose hours fit it.
  const applyReplace = (candidatePlace) => {
    const event = openingHoursFixEvent;
    const conflictingPlace = findConflictingPlace(event);
    const ids = (event.Places || "").split(",").map((id) => id.trim()).filter(Boolean);
    const idx = conflictingPlace ? ids.indexOf(String(conflictingPlace.ID)) : 0;
    ids[idx === -1 ? 0 : idx] = String(candidatePlace.ID);
    event.Places = ids.join(",");
    // Matches the convention used when an event is first built from a place
    // (Schedule.js: event.Subject = place.Name) — otherwise the card would
    // keep showing the old place's name after its place was swapped out. A
    // meal prefix ("Dinner at …", from Build Trip with AI) is kept.
    const mealPrefix = /^(breakfast|brunch|lunch|dinner) at /i.exec(event.Subject || "");
    event.Subject = mealPrefix ? `${mealPrefix[0]}${candidatePlace.Name}` : candidatePlace.Name;
    makeRoomForTravel(event);
    closeOpeningHoursFix();
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  // "Find a new place nearby": searches outside the guide for a similar
  // place open during this event (GooglePlaces.findOpenAlternatives).
  const findNewPlaceForFix = (callback) => {
    const event = openingHoursFixEvent;
    const closedPlace =
      findConflictingPlace(event) ||
      window.guide_obj.places.getPlace((event.Places || "").split(",").map((id) => id.trim()).filter(Boolean)[0]);
    if (!closedPlace) {
      callback([]);
      return;
    }
    const categoryName = (window.guide_obj.categoryNamesFromIDs(closedPlace.Category) || "").split(";")[0].trim();
    GooglePlaces.findOpenAlternatives(closedPlace, event.Subject, event.Start, event.End, categoryName, callback);
  };

  // Adds the chosen search result to the guide, then relinks the event to
  // it exactly like an unused-place replace. addPlace returns the ID to use
  // (it reassigns place.ID, or returns an existing duplicate's ID).
  const applyReplaceWithNew = (place) => {
    const newId = window.guide_obj.places.addPlace(place);
    const added = newId != null ? window.guide_obj.places.getPlace(newId) : null;
    if (!added) return;
    applyReplace(added);
  };

  const handleViewOpeningHoursFromFix = () => {
    const event = openingHoursFixEvent;
    closeOpeningHoursFix();
    viewOpeningHoursForEvent(event);
  };

  const handleEditEvent = (e, event) => {
    e.stopPropagation();
    dispatch(slice1Actions.setSelectedEvent({ value: event }));
    //Selevent = event;
    setShowEventMode("MODIFY");
    setShowEventWhere("after");
    setShowEventEdit(true);
  };

  // Opens the same "Place Details" HTML-reader page tapping a place
  // anywhere else in the app already goes to (Home.js's "placelink" case)
  // — stopPropagation so this doesn't also trigger the card's own
  // onClick (handleEventClicked) underneath it.
  const handleEventPhotoClicked = (e, place) => {
    e.stopPropagation();
    let htmlString = place.createPlaceDetailsHTML(place.Info, null, window.guide_obj, place.scheduledDates);
    htmlString = urlSchemeToFunctions(htmlString);
    dispatch(slice1Actions.setHTMLTitle({ value: "Place Details" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    // Unlike desktop (Map/Schedule shown alongside Home), mobile mode
    // shows one screen at a time, and the HTML reader only renders as
    // part of the "Home" screen — dispatching the content alone does
    // nothing visible while still on "Schedule". Same pattern every other
    // HTML-reader dispatch in ScheduleHeader.js already follows. Found
    // 2026-09-05 (real report: tapping the photo did nothing in mobile
    // mode).
    if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
  };

  const EventEditCallback = () => {
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const handleEventClicked = (e, event) => {
    const htmlString = event.createHTML(window.guide_obj.places);
    // EXPERIMENT, 2026-10-05: mobile mode gets a local dialog instead of
    // dispatching to the Home tab, for now — matches PlaceCard.js's/Map.js's
    // identical recent swap for place details. Desktop keeps dispatching to
    // Home (every panel is on screen at once there, so it's not a problem).
    if (MobileMode) {
      setEventHTMLContent(htmlString);
      setEventHTMLReaderShow(true);
      return;
    }
    dispatch(slice1Actions.setHTMLTitle({ value: "Event Details" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    window.location.href = "#home-start";
    const homeDiv = document.getElementById("home-content-start");
    if (homeDiv) homeDiv.scrollIntoView();
  };

  const sectionClicked = (section) => {
    section_clicked = section;
    // showDayScheduleFiltered();
    // return;
    if (GuideSettings.click_behavior !== "custom") {
      sectionClickedMenu(section);
      return;
    }
    if (GuideSettings.day.menu === true) sectionClickedMenu(section);
    if (GuideSettings.day.center === true) {
      showDayScheduleCentered();
    }
    if (GuideSettings.day.filter === true) {
      showDayScheduleFiltered();
    }
  };

  let section_clicked = null;

  // Lets the "N more options in Advanced Mode" hint reopen this same menu
  // (for the same day-section) after toggling, so newly-revealed items are
  // immediately visible. lastSectionRef is set whenever the menu actually
  // opens (not every render, since it needs the real argument); the wrapper
  // itself is refreshed every render so it always sees the just-updated
  // advancedMode value.
  const lastSectionRef = useRef(null);
  const sectionMenuRef = useRef(null);
  useEffect(() => {
    sectionMenuRef.current = () => { if (lastSectionRef.current) sectionClickedMenu(lastSectionRef.current); };
  });

  const sectionClickedMenu = (section) => {
    section_clicked = section;
    lastSectionRef.current = section;
    const buildMenuList = (advancedMode) => [
      {
        label: "Filter by this day",
        method: showDayScheduleFiltered,
        icon: null,
        visible: true,
        info: "Filter the guide places based on the places scheduled for this day.",
      },
      {
        label: "Move days events",
        method: moveOneDay,
        icon: null,
        visible: GuideEditMode && advancedMode,
        info: "Move all of the events scheduled for this day",
        videoKey: "move-events",
      },
      {
        label: "Set day start time",
        method: setDayStart,
        icon: null,
        visible: GuideEditMode,
        info: "Set the day start date and/or time",
        videoKey: "move-events",
      },
      {
        label: "Move all events starting",
        method: moveThisAndSubsequentDays,
        icon: null,
        visible: GuideEditMode && advancedMode,
        info: "Move all of the events scheduled for this day and all of days after this day to a new starting date and time. This will move multiple days.",
        videoKey: "move-events",
      },
      {
        label: "Recalculate Schedule",
        method: recalculateDayHandler,
        icon: null,
        visible: GuideEditMode,
        info: "Recalculate this day's event times based on place duration and travel distance, with an option to reorder events by location first.",
        videoKey: "recalculate-schedule",
      },
      {
        label: "Delete this one day",
        method: deleteOneDay,
        icon: null,
        visible: GuideEditMode && advancedMode,
        info: "Delete all of the events scheduled for this day. Essentially deletes the day.",
        videoKey: "move-events",
      },
    ];
    let menuList = buildMenuList(advancedMode);
    if (!advancedMode) {
      const hiddenCount = buildMenuList(true).filter((i) => i.visible).length - menuList.filter((i) => i.visible).length;
      if (hiddenCount > 0) {
        menuList = [
          ...menuList,
          {
            label: `${hiddenCount} more option${hiddenCount === 1 ? "" : "s"} in Advanced Mode`,
            method: () => {
              window.dispatchEvent(new CustomEvent("toggleAdvancedMode"));
              setTimeout(() => { if (sectionMenuRef.current) sectionMenuRef.current(); }, 350);
            },
            icon: null,
            visible: true,
            highlight: true,
            info: "Turn on Advanced Mode in Settings to see these options.",
          },
        ];
      }
    }

    //({ value: _MenuModalArgs }));
    setMenuModalList(menuList);
    setMenuModalHeading("Day Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("user")}></FontAwesomeIcon>);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const moveOneDay = () => {
    setMode("move_day");
    const label = section_clicked.Title;
    console.log(label);
    let date = new Date(label);
    date = Common.LuxonDateFromJSDate(date);
    console.log(date);
    setParamDate(date);
    setMoveEventsShow(true);
  };

  const setDayStart = () => {
    setMode("set_day_start");
    const label = section_clicked.Title;
    console.log(label);
    let date = new Date(label);
    date = Common.LuxonDateFromJSDate(date);
    date = date.plus({ hours: 9 });
    console.log(date);
    setParamDate(date);
    setMoveEventsShow(true);
  };

  const myAlert = (title, message, buttons) => {
    setAlertModalTitle(title);
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };

  // "Flag after the fact": the recalculation algorithm itself is never
  // modified to reschedule around closures. This just checks the results
  // afterward and summarizes any conflicts — the per-event warning badge
  // above picks them up automatically once state refreshes.
  const reportOpeningHoursConflicts = (itinerary, dayISO) => {
    const events = window.guide_obj.schedule.events.filter((e) => {
      const eventItinerary = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary.replace(/%20/g, " ");
      if (eventItinerary !== itinerary) return false;
      if (dayISO && DateTime.fromISO(e.Start, { zone: "utc" }).toISODate() !== dayISO) return false;
      return true;
    });
    const conflictCount = events.filter((e) => {
      const status = Place.getOpeningHoursConflict(e, window.guide_obj.places).status;
      return status === "closed" || status === "closes_during";
    }).length;
    if (conflictCount > 0) {
      myAlert(
        `${conflictCount} event${conflictCount === 1 ? "" : "s"} outside opening hours`,
        "Some events were scheduled at a time when the place appears to be closed. Look for the warning icon in the schedule to review them.",
        [{ Title: "OK", Method: null }]
      );
    }
  };

  // "Flag after the fact", same pattern as reportOpeningHoursConflicts —
  // recalculate only ever re-times EXISTING events (see Schedule.js's
  // pace_multiplier comment), it never adds or removes places. So a pace
  // change toward Packed can leave real unused time sitting at the end of a
  // day with nothing scheduled into it — surfaced here rather than done
  // silently, since filling that time back in means the user going to find
  // more places, not something recalculate can do for them. Threshold
  // avoids nagging over a trivial few minutes of slack. Found 2026-09-30,
  // user-requested after flagging that Build Trip with AI schedules (unlike
  // Build My Trip's usually-larger place pool) may have no spare places to
  // fill a newly packed day with.
  const IDLE_TIME_THRESHOLD_MINUTES = 60;
  const reportIdleTime = (itinerary, dayEndHour, dayISO) => {
    const events = window.guide_obj.schedule.events.filter((e) => {
      const eventItinerary = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary.replace(/%20/g, " ");
      if (eventItinerary !== itinerary) return false;
      if (dayISO && DateTime.fromISO(e.Start, { zone: "utc" }).toISODate() !== dayISO) return false;
      return true;
    });
    if (events.length === 0) return;
    const lastEndByDay = new Map();
    events.forEach((e) => {
      const dayKey = DateTime.fromISO(e.Start, { zone: "utc" }).toISODate();
      const end = DateTime.fromISO(e.End, { zone: "utc" });
      if (!lastEndByDay.has(dayKey) || end > lastEndByDay.get(dayKey)) lastEndByDay.set(dayKey, end);
    });
    let idleDayCount = 0;
    let totalIdleMinutes = 0;
    // Tracks the single biggest gap so "Find places" has one concrete day
    // to act on even when several days went idle at once — the alert text
    // still reports the full count/total, but the fill flow only ever
    // targets one day at a time (see openFillIdleTime).
    let biggestGapKey = null;
    let biggestGapMinutes = -1;
    for (const [dayKey, lastEnd] of lastEndByDay) {
      const dayEndTarget = DateTime.fromISO(dayKey + "T00:00:00.000Z", { zone: "utc" }).plus({ hours: dayEndHour });
      const idleMinutes = dayEndTarget.diff(lastEnd, "minutes").minutes;
      if (idleMinutes >= IDLE_TIME_THRESHOLD_MINUTES) {
        idleDayCount++;
        totalIdleMinutes += idleMinutes;
        if (idleMinutes > biggestGapMinutes) {
          biggestGapMinutes = idleMinutes;
          biggestGapKey = dayKey;
        }
      }
    }
    if (idleDayCount === 0) return;
    myAlert(
      "Free time in your schedule",
      `${idleDayCount} day${idleDayCount === 1 ? "" : "s"} now ${idleDayCount === 1 ? "has" : "have"} about ${Common.formatTravelDuration(Math.round(totalIdleMinutes))} of unused time before your day-end time.`,
      [
        { Title: "Not now", Method: null },
        { Title: "Find places", Method: () => openFillIdleTime(itinerary, biggestGapKey, dayEndHour) },
      ]
    );
  };

  const [fillIdleShow, setFillIdleShow] = useState(false);
  const [fillIdleDayLabel, setFillIdleDayLabel] = useState("");
  const [fillIdleRemainingMinutes, setFillIdleRemainingMinutes] = useState(0);
  const [fillIdleCandidates, setFillIdleCandidates] = useState([]);
  const fillIdleContextRef = useRef(null);

  // Recomputes the candidate list for the day/anchor/window currently in
  // fillIdleContextRef — called both when the dialog first opens and again
  // after each add, since adding a place shrinks the remaining window and
  // moves the anchor forward to the place just added.
  const refreshFillIdleCandidates = () => {
    const ctx = fillIdleContextRef.current;
    if (!ctx) return;
    const remainingMinutes = ctx.windowEnd.diff(ctx.windowStart, "minutes").minutes;
    setFillIdleRemainingMinutes(remainingMinutes);
    if (remainingMinutes < IDLE_TIME_THRESHOLD_MINUTES / 2) {
      setFillIdleCandidates([]);
      return;
    }
    // "Unused" in this schedule, unless the guide's schedules share places —
    // see Schedule.eventsCountedAsUsed. Same for Swap/Replace above.
    const candidates = Schedule.findFillCandidates(ctx.anchorPlace, ctx.windowStart, ctx.windowEnd, Schedule.eventsCountedAsUsed(ctx.itinerary), window.guide_obj.places);
    setFillIdleCandidates(candidates);
  };

  const openFillIdleTime = (itinerary, dayKey, dayEndHour) => {
    const dayEvents = window.guide_obj.schedule.events.filter((e) => {
      const eventItinerary = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary.replace(/%20/g, " ");
      return eventItinerary === itinerary && DateTime.fromISO(e.Start, { zone: "utc" }).toISODate() === dayKey;
    });
    if (dayEvents.length === 0) return;
    // Latest-ending event of the day, preferring one with a real place to
    // anchor distance from — falls back to the latest event overall (e.g. a
    // trailing placeholder like "Lunch") with no anchor, which
    // findFillCandidates treats as "don't filter by distance".
    const sorted = [...dayEvents].sort((a, b) => DateTime.fromISO(b.End, { zone: "utc" }) - DateTime.fromISO(a.End, { zone: "utc" }));
    const lastEvent = sorted[0];
    const lastWithPlace = sorted.find((e) => (e.Places || "").trim() !== "");
    const anchorPlace = lastWithPlace
      ? window.guide_obj.places.getPlace((lastWithPlace.Places || "").split(",")[0].trim())
      : null;
    const windowStart = DateTime.fromISO(lastEvent.End, { zone: "utc" });
    const windowEnd = DateTime.fromISO(dayKey + "T00:00:00.000Z", { zone: "utc" }).plus({ hours: dayEndHour });
    fillIdleContextRef.current = { itinerary, dayKey, dayEndHour, windowStart, windowEnd, anchorPlace };
    setFillIdleDayLabel(DateTime.fromISO(dayKey, { zone: "utc" }).toFormat("ccc, MMM d"));
    refreshFillIdleCandidates();
    setFillIdleShow(true);
  };

  const closeFillIdleTime = () => {
    setFillIdleShow(false);
    fillIdleContextRef.current = null;
  };

  // Places the chosen candidate via the same opening-hours-aware placement
  // Build My Trip uses (real travel time, real opening hours, same-day
  // only — see Schedule.js's addEventOpeningHoursAware) rather than
  // blindly appending it at windowStart; a candidate findFillCandidates
  // passed on its rough check can still fail this more precise one (e.g.
  // real travel time eats more of the window than the flat estimate did),
  // in which case it's just dropped from the refreshed list.
  const handleAddFillPlace = (place) => {
    const ctx = fillIdleContextRef.current;
    if (!ctx) return;
    const rounding_to = user_info.event_time_rounding ?? 15;
    const maxAllowedDate = DateTime.fromISO(ctx.dayKey + "T00:00:00.000Z", { zone: "utc" }).plus({ days: 1 });
    const newEnd = window.guide_obj.schedule.addEventOpeningHoursAware(
      place, ctx.itinerary, ctx.windowStart, ctx.anchorPlace, rounding_to, false,
      GuideSettings?.schedule_day_start ?? 9, ctx.dayEndHour, window.guide_obj.places, maxAllowedDate, 1, null
    );
    if (!newEnd) {
      // No longer fits (a more precise check than findFillCandidates' rough
      // pass) — drop it and let the user pick another.
      setFillIdleCandidates((prev) => prev.filter((p) => p.ID !== place.ID));
      return;
    }
    dispatch(slice1Actions.setGuide({ guide: null }));
    fillIdleContextRef.current = { ...ctx, windowStart: newEnd, anchorPlace: place };
    refreshFillIdleCandidates();
  };

  const recalculateDayHandler = () => {
    recalcDayDateRef.current = section_clicked.date;
    setRecalcDialogShow(true);
  };

  const runRecalculateDayHandler = ({ startHour, endHour, usePlaceDuration, avoidClosed, geography, paceMultiplier }) => {
    const dayDate = recalcDayDateRef.current;
    const result = window.guide_obj.schedule.recalculateDay(
      dayDate.toISODate(),
      ScheduleName,
      user_info.event_time_rounding,
      user_info.default_duration,
      window.guide_obj.places,
      geography,
      startHour,
      usePlaceDuration,
      avoidClosed,
      paceMultiplier,
      endHour
    );
    dispatch(slice1Actions.setGuide({ guide: null }));
    // Stops that didn't fit went to the next day — say so first (the other
    // two reports would only describe this day without them).
    const moved = movedToNextDayMessage(result?.movedToNextDay);
    if (moved) myAlert(moved.title, moved.body, [{ Title: "OK", Method: null }]);
    else {
      reportOpeningHoursConflicts(ScheduleName, dayDate.toISODate());
      reportIdleTime(ScheduleName, endHour, dayDate.toISODate());
    }
    if (DayConflictBanner === dayDate.toISODate())
      dispatch(slice1Actions.setDayConflictBanner({ value: null }));
  };

  // Triggered by the persistent day-conflict banner's own "Recalculate"
  // button (see EventModal.js's "Adjust Duration" flow, which sets
  // DayConflictBanner when a duration edit was saved without recalculating
  // and it now overlaps the next event) — reuses the same day-scoped
  // RecalculateDialog flow as the Day Menu's "Recalculate Schedule".
  const recalculateBannerDay = (dayISO) => {
    recalcDayDateRef.current = DateTime.fromISO(dayISO, { zone: "utc" });
    setRecalcDialogShow(true);
  };

  const deleteOneDay = () => {
    setMode("delete_day");
    const label = section_clicked.Title;
    let date = new Date(label);
    date = Common.LuxonDateFromJSDate(date);
    setParamDate(date);
    setMoveEventsShow(true);
  };

  const moveThisAndSubsequentDays = () => {
    setMode("move_all_days");
    const label = section_clicked.Title;
    let date = new Date(label);
    date = Common.LuxonDateFromJSDate(date);
    setParamDate(date);
    setMoveEventsShow(true);
  };

  const MoveEventsCallback = () => {
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const showDayScheduleFiltered = () => {
    //console.log(section);
    const label = section_clicked.Title;
    // section_clicked.date is already a UTC-zoned Luxon DateTime (see
    // getScheduleToDisplay2) — re-parsing the display label with new Date()
    // is locale/format-fragile and doesn't match getAllScheduledPlaces' UTC
    // day-boundary (see no-timezone convention).
    const dayTime = section_clicked.date.startOf("day").toMillis();
    const day_entry = {
      label: label,
      value: dayTime,
      // id: "9999999",
    };
    const AllScheduledPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName, dayTime);
    let hiddenPlacesToShow = [];
    AllScheduledPlaces.forEach((p) => {
      if (p.Hidden === true) hiddenPlacesToShow.push(p);
    });
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.setShowHiddenPlace({ value: hiddenPlacesToShow }));
    dispatch(slice1Actions.SetDatesFilter({ value: [day_entry] }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
    window.location.href = "#map-start";
  };

  const showDayScheduleCentered = () => {
    //console.log(section);
    const dayTime = section_clicked.date.startOf("day").toMillis();
    const AllScheduledPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName, dayTime);
    let hiddenPlacesToShow = [];
    AllScheduledPlaces.forEach((p) => {
      if (p.Hidden === true) hiddenPlacesToShow.push(p);
    });
    dispatch(slice1Actions.setShowHiddenPlace({ value: hiddenPlacesToShow }));
    if (AllScheduledPlaces.length !== 0) {
      dispatch(slice1Actions.ClearAllFilters());
      dispatch(slice1Actions.centerMapToPlaces({ value: AllScheduledPlaces }));
      if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
      else window.location.href = "#map-start";
    }
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
    window.location.href = "#map-start";
  };

  const handleDragStart = (e, index, event) => {
    //e.target.style.backgroundColor = "#ffff";
    setdragEvent(event);
  };

  const handleDragEnter = (e, index, event) => {};

  const handleDragLeave = (e) => {
    //e.target.style.backgroundColor = "#ffff";
  };

  const handleDrop = (e, event) => {
    if (dragEvent === null) return false;
    //e.target.style.backgroundColor = "#336699";
    window.guide_obj.schedule.reorderEvents(dragEvent, event, ScheduleName);
    dispatch(slice1Actions.setGuide({ guide: null }));
    setdragEvent(null);
  };

  // Replaces the old hover-triggered enterLeave/highlightPlace pair
  // (onMouseEnter/onMouseLeave on the crosshairs span) — hovering used to
  // scroll to and highlight the matching place card, open Place Details (by
  // hijacking the Home tab's content), and in mobile mode navigate away to
  // the Home screen entirely, none of it undone on mouse-leave. Too
  // disruptive for an accidental hover, and in mobile mode's single-panel
  // layout a plain highlight is invisible anyway (the Places panel isn't
  // even on screen) — centering the map is the one action that's
  // meaningful in both layouts, so the crosshairs now does exactly what its
  // icon says: center on map, on click, mirroring PlaceCard.js's own
  // handleCenterInMap. Found/fixed 2026-09-07.
  const centerEventOnMap = (event) => {
    let places = event.Places;
    if (!Array.isArray(event.Places)) places = event.Places.split(",");
    if (places.length === 0) return;
    const place = window.guide_obj.places.getPlace(places[0]);
    if (place == null) return;
    dispatch(slice1Actions.setHighlightedPlaces({ value: places }));
    if (MobileMode) {
      dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
      dispatch(slice1Actions.centerMapToPlaces({ value: [place] }));
    } else {
      dispatch(slice1Actions.centerMapToPlaces({ value: [place] }));
      window.location.href = "#map-start";
    }
  };

  // Tapping the travel row between two events (see the estimated-travel
  // connector below) opens the same Directions dialog the Map's own "Get
  // directions" uses, pre-filled From/To — the schedule-build estimate is
  // only ever a distance guess, so this is the one-tap way to get a real
  // Google answer for a specific leg instead of trusting it.
  // ── The hotel a day starts from (2026-10-16) ──
  // A hotel is a place with the guide's Hotel category, so "setting" one
  // gives a place that category (or adds the found hotel as a new place).
  const hotelCategoryId = () => [...hotelCategoryIds(window.guide_obj.categories)][0] || "16";
  const markHotel = (place) => {
    const id = String(hotelCategoryId());
    // Only categories this guide has — a searched place arrives with raw
    // place types ("lodging", "hotel"…), which showed as "NA". Hotel first.
    const known = new Set((window.guide_obj.categories || []).map((c) => String(c.id)));
    const kept = (Array.isArray(place.Category) ? place.Category : []).map(String).filter((c) => known.has(c) && c !== id);
    place.Category = [id, ...kept];
    dispatch(slice1Actions.setGuideHasUnsavedChanges({ value: true }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };
  const hotelPickItems = () => {
    if (!hotelPick) return [];
    const city = (hotelPick.city || "").toLowerCase();
    const near = hotelPick.near;
    const inCity = (window.guide_obj.places.placesList || [])
      .filter((p) => !p.Hidden && (!p.PType || p.PType === "Icon") && (p.City || "").toLowerCase() === city)
      .sort((a, b) => Common.haversineMeters(a.Lat, a.Longi, near.Lat, near.Longi) - Common.haversineMeters(b.Lat, b.Longi, near.Lat, near.Longi));
    return [
      { id: "search", label: "Search for my hotel…", name: "Search for my hotel…", value: "search" },
      ...inCity.map((p) => ({ id: p.ID, label: p.Name, name: p.Name, value: p.ID })),
    ];
  };
  const onHotelPicked = (items) => {
    const pick = hotelPick;
    setHotelPick(null);
    const item = items && items[0];
    if (!item || !pick) return;
    if (item.value === "search") { setHotelSearchFor(pick); return; }
    const place = window.guide_obj.places.getPlace(item.value);
    if (place) markHotel(place);
  };
  const searchHotel = (name, pick) => {
    if (!name || !pick) return;
    const gp = new GooglePlaces();
    gp.searchPlacesNewAPI(`${name}, ${pick.city}${pick.country ? ", " + pick.country : ""}`, null, pick.near.Lat, pick.near.Longi, 30000, (results) => {
      const found = results && results[0];
      if (!found) {
        setHotelMessage(`Couldn't find "${name}" in ${pick.city}. Check the name, or add the hotel as a place and choose it from the list.`);
        return;
      }
      found.City = pick.city;
      found.Country = found.Country || pick.country || "";
      window.guide_obj.places.addPlace(found);
      markHotel(found);
    });
  };

  const openDirectionsForLeg = (fromPlace, toPlace) => {
    const from = { Name: fromPlace.Name, Lat: fromPlace.Lat, Longi: fromPlace.Longi };
    const to = { Name: toPlace.Name, Lat: toPlace.Lat, Longi: toPlace.Longi };
    // Consumed once by DirectionsDialogComponent's exitDialog — a quick
    // one-leg preview from the schedule shouldn't leave From/To markers
    // sitting on the Map needing manual "Clear" after the user's just
    // closed the dialog. Doesn't affect the Map's own "Get Directions",
    // which never sets this flag and keeps its current behavior (route
    // persists until Clear). Real report: 2026-09-26.
    window.DirectionsAutoClearOnExit = true;
    window.DirectionsFromLocation = from;
    window.DirectionsToLocation = to;
    window.DirectionsWaypointsLocation = [];
    window.DirectionsFromPlace = [{ Name: fromPlace.Name, ID: fromPlace.ID }];
    window.DirectionsToPlace = [{ Name: toPlace.Name, ID: toPlace.ID }];
    window.DirectionsWaypointPlaces = [];
    dispatch(slice1Actions.setDirectionsFromLocation({ value: from }));
    dispatch(slice1Actions.setDirectionsToLocation({ value: to }));
    dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: [] }));
    dispatch(slice1Actions.setShowOffcanvas({ value: true }));
  };

  const handleDragStartDay = (e, index, dragDay) => {
    let dayBeforeDragDay = schedule[0];
    if (index > 0) dayBeforeDragDay = schedule[index - 1];
    let dayAfterDragDay = schedule[schedule.length - 1];
    if (index < schedule.length - 1) dayAfterDragDay = schedule[index + 1];
    setdragDay({ dragDay: dragDay, dayBeforeDragDay: dayBeforeDragDay, dayAfterDragDay: dayAfterDragDay });
    //console.log("handleDragStartDay", dragDay);
  };

  const handleDragEnterDay = (e, index, dropDay) => {};

  const handleDragLeaveDay = (e) => {
    //e.target.style.backgroundColor = "#ffff";
  };

  const handleDropDay = (e, dropIndex, dropDay) => {
    //e.target.style.backgroundColor = "#ffff";
    if (dragDay === null) return false;
    console.log("handleDragEnterDay");
    let dayAfterDropDay = schedule[schedule.length - 1];
    if (dropIndex < schedule.length - 1) dayAfterDropDay = schedule[dropIndex + 1];
    window.guide_obj.schedule.reorderDays(
      dragDay.dragDay,
      dragDay.dayBeforeDragDay,
      dragDay.dayAfterDragDay,
      dropDay,
      dayAfterDropDay,
      ScheduleName,
      dropIndex === schedule.length - 1
    );
    setdragDay(null);
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const enterLeaveDay = (day, enter) => {
    // let places = event.Places;
    // if (!Array.isArray(event.Places)) places = event.Places.split(",");
    // if (enter === true) {
    //   dispatch(slice1Actions.setHighlightedPlaces({ value: places }));
    //   if (places.length !== 0) {
    //     const place = window.guide_obj.places.getPlace(places[0]);
    //     if (place !== null) {
    //       var placeElement = document.getElementById(`PlaceCard${places[0]}`);
    //       if (placeElement !== null) {
    //         placeElement.scrollIntoView();
    //         placeElement.style.backgroundColor = "yellow";
    //       }
    //     }
    //   }
    // } else {
    //   dispatch(slice1Actions.setHighlightedPlaces({ value: [] }));
    //   if (places.length !== 0) {
    //     const place = window.guide_obj.places.getPlace(places[0]);
    //     if (place !== null) {
    //       placeElement = document.getElementById(`PlaceCard${places[0]}`);
    //       if (placeElement !== null) {
    //         placeElement.style.backgroundColor = "#ffffff";
    //       }
    //     }
    //   }
    // }
  };

  const assignID = (event, index) => {
    let places = event.Places;
    if (!Array.isArray(event.Places)) places = event.Places.split(",");
    if (places.length !== 0) return `eventID${places[0]}`;
    else return `eventIndex${index}`;
  };
  // Every event of the schedule shown (not just the filtered days on screen),
  // so a day's start row knows where the day before ended.
  const scheduleEventsAll = window.guide_obj?.schedule?.getEventsFromSchedule?.(ScheduleName || "Main") || [];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
    <div
      id="ScheduleDiv"
      style={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
        overflowY: "auto",
        padding: "0 10px",
      }}
    >
      {!LoadingGuide && EventSearchText !== "" ? (
        <div className="sp-filter-banner" onClick={() => clearEventSearchText()}>
          <p>Filtered — click to show all</p>
        </div>
      ) : null}
      {schedule.length === 0 && ScheduleNames.length > 1 && !LoadingGuide && EventSearchText === "" ? (
        <div className="sp-empty-card">
          No events in this schedule. Choose a different schedule or add events using the "+" icon above.
        </div>
      ) : null}

      <a id="schedule-show"></a>
      {schedule.length === 0 && ScheduleNames.length === 1 && !LoadingGuide && EventSearchText === "" ? (
        <div className="sp-empty-card">
          No events in guide. Add them using the "+" icon above.
        </div>
      ) : null}
      {schedule.map((_schedule, i) => (
        <div
          key={i}
          id={`schedule-day-${_schedule.date?.toISODate?.() ?? i}`}
          className="sp-day-section"
          draggable={dndEnabled}
          onDragStart={dndEnabled ? (e) => handleDragStartDay(e, i, _schedule, true) : undefined}
          onDragEnter={dndEnabled ? (e) => handleDragEnterDay(e, i, _schedule) : undefined}
          onDragLeave={dndEnabled ? (e) => handleDragLeaveDay(e, _schedule) : undefined}
          onDrop={dndEnabled ? (e) => handleDropDay(e, i, _schedule) : undefined}
          onDragOver={dndEnabled ? (e) => e.preventDefault() : undefined}
        >
          <div
            className="sp-day-header"
            onClick={() => sectionClicked(_schedule)}
            onMouseEnter={() => enterLeaveDay(_schedule, true)}
            onMouseLeave={() => enterLeaveDay(_schedule, false)}
          >
            {dndEnabled && (
              <span className="sp-day-grip">
                <FontAwesomeIcon icon={solid("grip-vertical")} />
              </span>
            )}
            <span className="sp-day-title">
              {_schedule.data && _schedule.data.length > 0 ? `${_schedule.data[0].dayNum}: ${_schedule.Title}` : _schedule.Title}
              {_schedule.City ? <span className="sp-day-city"> — {_schedule.City}</span> : null}
            </span>
            <button
              className="sp-day-btn"
              onClick={(e) => showDayMenu(e, _schedule)}
              title="Day menu"
            >
              <FontAwesomeIcon icon={solid("ellipsis")} />
            </button>
          </div>
          {DayConflictBanner === _schedule.date?.toISODate?.() && (
            <div className="sp-conflict-banner">
              <FontAwesomeIcon icon={solid("triangle-exclamation")} />
              <span className="sp-conflict-banner-text">
                A duration change now overlaps the next event this day.
              </span>
              <button
                className="sp-conflict-banner-action"
                onClick={() => recalculateBannerDay(_schedule.date.toISODate())}
              >
                Recalculate
              </button>
              <button
                className="sp-conflict-banner-dismiss"
                onClick={() => dispatch(slice1Actions.setDayConflictBanner({ value: null }))}
                aria-label="Dismiss"
              >
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>
          )}
          <div className="sp-day-items">
            {(() => {
              // Travel to the day's first place: from the hotel, or from the
              // previous city on an arrival day. See dayStartTravel.js.
              if (!_schedule.data || _schedule.data.length === 0 || !_schedule.date?.toISODate) return null;
              const leg = dayStartLeg({
                dayDate: DateTime.fromISO(_schedule.date.toISODate(), { zone: "utc" }),
                firstEvent: _schedule.data[0],
                events: scheduleEventsAll,
                places: window.guide_obj.places,
                categories: window.guide_obj.categories,
                destinations: window.guide_obj.destinations,
              });
              if (!leg) return null;
              if (leg.kind === "noHotel") {
                if (!GuideEditMode) return null;
                return (
                  <div
                    className="sp-travel-row sp-travel-start sp-travel-unknown"
                    onClick={(e) => { e.stopPropagation(); setHotelPick({ city: leg.city, country: leg.to.Country || "", near: leg.to }); }}
                    title={`Set your hotel in ${leg.city || "this city"} to see travel times`}
                  >
                    <FontAwesomeIcon icon={solid("hotel")} className="sp-travel-icon" />
                    <span className="sp-travel-text">From your hotel · tap to set it</span>
                  </div>
                );
              }
              if (!leg.travel) return null;
              return (
                <div
                  className="sp-travel-row sp-travel-start"
                  onClick={(e) => { e.stopPropagation(); openDirectionsForLeg(leg.from, leg.to); }}
                  title="Get directions for this leg"
                >
                  <FontAwesomeIcon icon={leg.kind === "hotel" ? solid("hotel") : TRAVEL_MODE_ICONS[leg.travel.mode]} className="sp-travel-icon" />
                  <span className="sp-travel-text">From {leg.kind === "hotel" ? leg.from.Name : leg.fromCity} · {leg.travel.distanceLabel} · ~{Common.formatTravelDuration(leg.travel.minutes)}</span>
                </div>
              );
            })()}
            {_schedule.data.map((_event, index) => {
              const hoursConflict = Place.getOpeningHoursConflict(_event, window.guide_obj.places);
              // "closed" (not open yet at the event's start) and
              // "closes_during" (open at the start but the place's current
              // period ends before the event does — the whole event must
              // fit within the open period, not just the start) both get
              // the warning treatment; see Place.getOpeningHoursConflict.
              const isClosed = hoursConflict.status === "closed" || hoursConflict.status === "closes_during";
              // closedAllDay: unfixable by reordering within the day, needs
              // a different day. Otherwise say WHY briefly — when it opens
              // or when it closes — rather than just "Closed", so a
              // schedule reviewer doesn't have to open the place's own
              // hours to find that out. minutesUntilOpen/minutesUntilClose
              // are only absent when there's no more-specific info (no
              // remaining period today, or no hours data at all).
              const closedLabel = hoursConflict.closedAllDay
                ? "Closed all day"
                : hoursConflict.status === "closes_during" && typeof hoursConflict.minutesUntilClose === "number"
                ? `Closes at ${Common.formatTimeBrief(
                    DateTime.fromISO(_event.Start, { zone: "utc" }).plus({ minutes: hoursConflict.minutesUntilClose }).toISO()
                  )}`
                : typeof hoursConflict.minutesUntilOpen === "number"
                ? `Opens at ${Common.formatTimeBrief(
                    DateTime.fromISO(_event.Start, { zone: "utc" }).plus({ minutes: hoursConflict.minutesUntilOpen }).toISO()
                  )}`
                : "Closed";
              return (
              <React.Fragment key={index}>
              <div
                id={assignID(_event, index)}
                className={`sp-card${isClosed ? " sp-card-warning" : ""}`}
                onClick={(e) => handleEventClicked(e, _event)}
                draggable={dndEnabled}
                onDragStart={dndEnabled ? (e) => handleDragStart(e, index, _event, false) : undefined}
                onDragEnter={dndEnabled ? (e) => handleDragEnter(e, index, _event) : undefined}
                onDragLeave={dndEnabled ? (e) => handleDragLeave(e, _event) : undefined}
                onDrop={dndEnabled ? (e) => handleDrop(e, _event) : undefined}
                onDragOver={dndEnabled ? (e) => e.preventDefault() : undefined}
              >
                <div className="sp-card-inner">
                  <div className="sp-card-content">
                    <div className="sp-time-row">
                      {dndEnabled && (
                        <span className="sp-event-grip">
                          <FontAwesomeIcon icon={solid("grip-vertical")} />
                        </span>
                      )}
                      {(() => {
                        // "Has a place" indicator, on the time line since 2026-10-27
                        // (a leading column of its own pushed these cards' text right of
                        // place-less events' and squeezed the times). Replaced the photo
                        // thumbnail shipped 2026-09-05 (see memory:
                        // project_schedule_row_thumbnail_idea). This list isn't
                        // virtualized — every event for the whole trip mounts at
                        // once — so a photo per row meant loading every place
                        // photo simultaneously; for a guide with many Google
                        // Drive-sourced photos that triggered the same
                        // lh3.googleusercontent.com throttling documented in
                        // ExportVideoModal.js's loadImagesBounded, showing broken
                        // thumbnails across the whole schedule. Mobile hit this
                        // identical problem for the identical reason and already
                        // reverted to a lightweight icon the same day it shipped
                        // — matching that here now. Keeps the original
                        // click-to-open-place-details affordance the photo used
                        // to provide. Found 2026-09-24.
                        const eventPlaceId = (_event.Places || "").split(",")[0]?.trim();
                        const eventPlace = eventPlaceId ? window.guide_obj.places.getPlace(eventPlaceId) : null;
                        if (!eventPlace) return null;
                        return (
                          <div
                            className="sp-place-indicator"
                            onClick={(e) => handleEventPhotoClicked(e, eventPlace)}
                            title={eventPlace.Name}
                          >
                            <FontAwesomeIcon icon={solid("location-dot")} />
                          </div>
                        );
                      })()}
                      {/* Only these two ever shrink/truncate — the button
                          group below is a separate flex item with
                          flex-shrink:0, so its width is structurally
                          reserved no matter how tight this gets, instead
                          of relying on per-item flex-basis/shrink math to
                          work out. Found 2026-09-17 (iPhone 7 web mobile
                          mode): the last icon button rendered partly
                          outside the card's right edge without this. */}
                      <div className="sp-time-info">
                        <span className="sp-time-text">
                          {`${Common.formatTimeLuxon(_event.Start, null)} – ${Common.formatTimeLuxon(_event.End, null)}`}
                        </span>
                        {isClosed && (
                          <button
                            className="sp-warning-badge"
                            onClick={(e) => handleShowOpeningHoursConflict(e, _event)}
                            title={`${closedLabel} — fix this scheduling conflict`}
                          >
                            <FontAwesomeIcon icon={solid("triangle-exclamation")} />
                            <span className="sp-warning-badge-text">Closed</span>
                          </button>
                        )}
                      </div>
                      <div className="sp-time-actions">
                        <button
                          className="sp-icon-btn"
                          onClick={(e) => handleEditEvent(e, _event)}
                          title="Edit event"
                        >
                          <FontAwesomeIcon icon={solid("pencil")} />
                        </button>
                        <button
                          className="sp-icon-btn"
                          onClick={(e) => showEventMenu(e, _event)}
                          title="Event menu"
                        >
                          <FontAwesomeIcon icon={solid("ellipsis")} />
                        </button>
                        <button
                          className="sp-crosshair"
                          onClick={(e) => { e.stopPropagation(); centerEventOnMap(_event); }}
                          title="Center on map"
                        >
                          <FontAwesomeIcon icon={solid("crosshairs")} />
                        </button>
                      </div>
                    </div>
                    <p className="sp-subject">
                      {`${typeof _event.order_index === "undefined" ? "" : _event.order_index} ${_event.Subject}`}
                    </p>
                  </div>
                </div>
              </div>
              {index === _schedule.data.length - 1 && _schedule.date?.toISODate && (() => {
                // Leaving for the next city this evening (its arrival time,
                // per the destination dates, is later today): "To Florence".
                const leg = dayEndLeg({
                  dayDate: DateTime.fromISO(_schedule.date.toISODate(), { zone: "utc" }),
                  lastEvent: _event,
                  events: scheduleEventsAll,
                  places: window.guide_obj.places,
                  destinations: window.guide_obj.destinations,
                });
                if (!leg || !leg.travel) return null;
                return (
                  <div
                    className="sp-travel-row"
                    onClick={(e) => { e.stopPropagation(); openDirectionsForLeg(leg.from, leg.to); }}
                    title="Get directions for this leg"
                  >
                    <FontAwesomeIcon icon={TRAVEL_MODE_ICONS[leg.travel.mode]} className="sp-travel-icon" />
                    <span className="sp-travel-text">To {leg.toCity} · {leg.travel.distanceLabel} · ~{Common.formatTravelDuration(leg.travel.minutes)}</span>
                  </div>
                );
              })()}
              {index < _schedule.data.length - 1 && (() => {
                // Estimated only (see Common.estimateTravel) — not the
                // scheduler's own recorded value (nothing persists one per
                // leg), so this can drift from reality exactly as much as
                // the estimate itself does. Tapping it opens real Directions
                // for anyone who wants an actual answer for this leg.
                const nextEvent = _schedule.data[index + 1];
                const fromId = (_event.Places || "").split(",")[0]?.trim();
                const toId = (nextEvent.Places || "").split(",")[0]?.trim();
                const fromPlace = fromId ? window.guide_obj.places.getPlace(fromId) : null;
                const toPlace = toId ? window.guide_obj.places.getPlace(toId) : null;
                const travel = fromPlace && toPlace ? Common.estimateTravel(fromPlace, toPlace) : null;
                if (!travel) return null;
                return (
                  <div
                    className="sp-travel-row"
                    onClick={(e) => { e.stopPropagation(); openDirectionsForLeg(fromPlace, toPlace); }}
                    title="Get directions for this leg"
                  >
                    <FontAwesomeIcon icon={TRAVEL_MODE_ICONS[travel.mode]} className="sp-travel-icon" />
                    <span className="sp-travel-text">{travel.distanceLabel} · ~{Common.formatTravelDuration(travel.minutes)}</span>
                  </div>
                );
              })()}
              </React.Fragment>
              );
            })}
          </div>
        </div>
      ))}
      {hotelPick ? (
        <MultiSelectModal
          show={true}
          onHide={() => setHotelPick(null)}
          MultiselectItems={hotelPickItems()}
          MultiselectSelectedItems={[]}
          MultiselectMode="uni"
          MultiselectCallback={onHotelPicked}
          MultiselectTitle={`Your hotel in ${hotelPick.city || "this city"}`}
          MultiselectSearchText=""
        />
      ) : null}
      {hotelSearchFor ? (
        <PromptModal
          show={true}
          onHide={() => setHotelSearchFor(null)}
          PromptModalTitle={`Your hotel in ${hotelSearchFor.city || "this city"}`}
          PromptModalMessage="The hotel's name — it's added to this guide's places as your hotel."
          PromptModalInputs={[{ name: "Hotel name", value: "" }]}
          PromptModalButtons={[
            { Title: "Find", Method: (inputs) => searchHotel((inputs?.[0]?.value || "").trim(), hotelSearchFor) },
            { Title: "Cancel", Method: null },
          ]}
        />
      ) : null}
      {hotelMessage ? (
        <AlertModal show={true} onHide={() => setHotelMessage(null)} AlertModalTitle="Hotel not found" AlertModalMessage={hotelMessage} AlertModalButtons={[{ Title: "OK", Method: null }]} />
      ) : null}
      <EventModal
        show={eventModal}
        onHide={() => setEventModal(false)}
        onSwapEvent={(event) => {
          setEventModal(false);
          openSwapForEvent(event);
        }}
      />
      <HTMLReader
        html={EventHTMLContent}
        show={EventHTMLReaderShow}
        title="Event Details"
        onHide={() => setEventHTMLReaderShow(false)}
      />
      {MenuModalShow ? (
        <MenuModal
          id="MenuModal"
          show={MenuModalShow}
          onHide={() => setMenuModalShow(false)}
          menu_modal_list={MenuModalList}
          menu_modal_heading={MenuModalHeading}
          menu_model_image={MenuModalImage}
          menu_modal_place={MenuModalPlace}
        />
      ) : null}
      {MoveEventsShow ? (
        <MoveEvents
          show={MoveEventsShow}
          onHide={() => setMoveEventsShow(false)}
          ScheduleName={ScheduleName}
          ScheduleNames={ScheduleNames}
          mode={Mode}
          param_date={ParamDate}
          callback={MoveEventsCallback}
        />
      ) : null}
      {ShowEventEdit ? (
        <EventEdit
          show={ShowEventEdit}
          onHide={() => setShowEventEdit(false)}
          event={event}
          mode={EventEditMode}
          place={null}
          where={EventEditWhere}
          schedule_name={ScheduleName}
          callback={() => EventEditCallback()}
        />
      ) : null}
      {RecalcDialogShow && (
        <RecalculateDialog
          show={RecalcDialogShow}
          onHide={() => setRecalcDialogShow(false)}
          onConfirm={runRecalculateDayHandler}
          defaultStart={GuideSettings.schedule_day_start ?? 9}
          defaultEnd={GuideSettings.schedule_day_end ?? 20}
        />
      )}
      {AlertModalShow ? (
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
      ) : null}
      {conflictPlaceEditShow && conflictPlace ? (
        <PlaceEditModal
          show={conflictPlaceEditShow}
          onHide={() => setConflictPlaceEditShow(false)}
          place={conflictPlace}
          id={conflictPlace.ID}
          name={conflictPlace.Name}
          groups={window.guide_obj == null ? "" : window.guide_obj.groupNamesFromIDs(conflictPlace.Group)}
          category={window.guide_obj == null ? "" : window.guide_obj.categoryNamesFromIDs(conflictPlace.Category)}
          user_info={user_info}
          mode={"Edit"}
          update_display={() => dispatch(slice1Actions.setGuide({ guide: null }))}
          scrollToOpeningHours={true}
        />
      ) : null}
      <OpeningHoursFixModal
        show={openingHoursFixShow}
        onHide={closeOpeningHoursFix}
        event={openingHoursFixEvent}
        conflict={openingHoursFixConflict}
        candidates={openingHoursFixCandidates}
        replaceCandidates={openingHoursFixReplaceCandidates}
        replaceChecking={replaceChecking}
        replaceLimited={replaceLimited}
        mode={openingHoursFixMode}
        onPushStart={applyPushStart}
        onPullEnd={applyPullEnd}
        onSwap={applySwap}
        onReplace={applyReplace}
        onViewHours={handleViewOpeningHoursFromFix}
        onFindNew={findNewPlaceForFix}
        onReplaceWithNew={applyReplaceWithNew}
      />
      <FillIdleTimeModal
        show={fillIdleShow}
        onHide={closeFillIdleTime}
        dayLabel={fillIdleDayLabel}
        remainingMinutes={fillIdleRemainingMinutes}
        candidates={fillIdleCandidates}
        onAdd={handleAddFillPlace}
      />
    </div>
    </div>
  );
};

export default SchedulePanel;
